import numeral from 'numeral';
import PropTypes from 'prop-types';

import BlokoLink from 'bloko/blocks/link';

import useTrls from 'hooks/translation/useTrls';

import 'components/Admin/Reports/ActsReport/ActsTable/Act/Invoices/Invoices.less';

const Invoices = ({ invoices }) => {
    const trl = useTrls();

    return (
        <table className="invoices">
            <thead>
                <tr className="invoices__row">
                    <th className="invoices__head">{trl('admin.actsReport.actsTable.invoice.number')}</th>
                    <th className="invoices__head">{trl('admin.actsReport.actsTable.invoice.amount')}</th>
                </tr>
            </thead>
            <tbody>
                {invoices.map((invoice, index) => (
                    <tr className="invoices__row" key={index}>
                        <td className="invoices__cell">
                            <BlokoLink href={`/new/admin/invoices/${invoice.id}/`} target="_blank">
                                {invoice.id}
                            </BlokoLink>
                        </td>
                        <td className="invoices__cell">{numeral(invoice.amount).format('0,0')}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

Invoices.propTypes = {
    invoices: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            amount: PropTypes.number,
        })
    ),
};

export default Invoices;
